import type { NewsletterGuardrailEvaluation } from './newsletterUtils';

export type WindowLimits = { per_second: number | null; per_hour: number | null; per_24h: number | null; per_30d: number | null };
export type NewsletterProtectionDecision = {
  schema_version: 2;
  evaluated_at: string;
  policy_version: string;
  scope: 'account' | 'campaign';
  route: { profile: string; label: string };
  configuration: { state: 'ready' | 'unknown' | 'blocked'; checks: Array<{code: string; state: 'verified' | 'failed' | 'unknown' | 'not_applicable'; source: string; checked_at: string | null}> };
  capacity: { state: string; provider_limits: WindowLimits; relyo_limits: WindowLimits; send_now_count: number | null; deferred_count: number | null; next_window_at: string | null; snapshot_at: string | null };
  observability: Record<string, {coverage: string; source: string; observed_count: number | null; start_at: string | null; end_at: string | null}>;
  incidents: Array<{code: string; scope: string; count: number; denominator: number; rate: number | null; window_start: string | null; window_end: string; source: string; action: string}>;
  action: {kind: 'send' | 'defer' | 'pause' | 'block'; reason_codes: string[]; retry_at: string | null; review_required: boolean; recovery_allowed?: boolean};
  tracking: {enabled: boolean; method: 'shared_pixel' | 'disabled'};
  route_recommendation: {code: string; message: string; available: boolean} | null;
};

// Presentation adapter for composer scheduling fields during the v2 UI migration.
// Every count and decision comes from the server; there are no frontend thresholds.
export function protectionView(p: NewsletterProtectionDecision): NewsletterGuardrailEvaluation {
  return {
    protection: p, account_mode: 'normal', sending_route_profile: p.route.profile,
    provider_label: p.route.label, copy_variant: 'protection', reason_codes: p.action.reason_codes,
    tracking_state: 'available', batch_size: 20, batch_delay_seconds: 180, batch_delay_jitter_ratio: 0,
    max_per_day: p.capacity.relyo_limits.per_24h ?? 0, max_campaign_now: p.capacity.relyo_limits.per_24h ?? 0,
    provider_limit_snapshot: {}, relyo_safe_limit_snapshot: {},
    send_now_recipient_count: p.capacity.send_now_count ?? 0, send_now_remaining_count: p.capacity.send_now_count ?? 0,
    deferred_recipient_count: p.capacity.deferred_count ?? 0, current_window_recipient_cap: p.capacity.send_now_count ?? 0,
    next_send_window_at: p.capacity.next_window_at, campaign_delivery_state: p.action.kind === 'defer' ? 'waiting_window' : 'ready',
    sent_recipient_count: 0, remaining_recipient_count: null, delivery_progress_percent: 0,
    summary_title: 'Protection des envois', summary_message: '', summary_points: [],
    allowed_actions: {}, delivery_health_snapshot: {},
  } as unknown as NewsletterGuardrailEvaluation;
}

export function canReviewSendingList(decision?: NewsletterProtectionDecision) {
  return decision?.action.kind === 'pause' && decision.action.recovery_allowed === true && decision.action.review_required
    && decision.action.reason_codes.length > 0
    && decision.action.reason_codes.every(code => ['hard_bounces', 'complaints'].includes(code));
}
